import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

/**
 * Animated Tooltip（Aceternity UI 风格）— 悬停时弹出并跟随的提示
 */
export function AnimatedTooltip({
  content,
  children,
  className = '',
}: {
  content: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  const [hovered, setHovered] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  return (
    <div
      className={`relative inline-flex ${className}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => { setHovered(false); setOffset({ x: 0, y: 0 }); }}
      onMouseMove={(e) => {
        const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
        setOffset({ x: e.clientX - (rect.left + rect.width / 2), y: e.clientY - (rect.top + rect.height / 2) });
      }}
    >
      {children}
      <AnimatePresence>
        {hovered && (
          <motion.div
            initial={{ opacity: 0, scale: 0.85, y: 6 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 4 }}
            transition={{ type: 'spring', stiffness: 400, damping: 24 }}
            style={{ translateX: offset.x, translateY: offset.y - 8 }}
            className="pointer-events-none absolute left-1/2 top-0 z-50 -translate-x-1/2 -translate-y-full whitespace-nowrap rounded-xl border border-border-soft bg-card/95 px-3 py-1.5 text-xs font-semibold text-text shadow-xl backdrop-blur-xl"
          >
            {content}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
